import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const ToggleFavouriteDisplays = {
  name: 'toggleFavouriteDisplays',
  state: {
    loading: false,
    error: '',
    success: '',
  },
  reducers: {
    toggleRequested(state) {
      return { ...state, loading: true, error: '', success: '' };
    },

    toggleSucceeded(state, payload) {
      return { ...state, loading: false, success: payload.message, error: '' };
    },

    toggleFailed(state, payload) {
      return { ...state, loading: false, error: payload, success: '' };
    },

    clearMessages(state) {
      return { ...state, error: '', success: '' };
    },
  },
  effects: (dispatch) => ({
    async toggleFavouriteDisplays({ display_id, org_id }) {
      try {
        this.toggleRequested();

        const response = await http.put(`savvy/displays/toggle-favourite/${display_id}`, { org_id });
        this.toggleSucceeded(response.data);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: response.data.message,
            show: true,
          },
        });
      } catch (error) {
        const errorMessage = responseMessageHandler.show(error.message);
        this.toggleFailed(errorMessage);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: errorMessage,
            show: true,
          },
        });
      }
    },

    async clearStateMessages() {
      this.clearMessages();
    },
  }),
};

export default ToggleFavouriteDisplays;
